export default __webpack_public_path__ + "static/uchicago-shield-47387f40d9883d746bcca9874ed84ad4.png";